import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import Buefy from 'buefy'
import '@/assets/buefy-sliced.css'
import firebase from 'firebase/app'
import i18n from '@/i18n'
// import Ads from 'vue-google-adsense'
import VueMobileDetection from 'vue-mobile-detection'
import LoadScript from 'vue-plugin-load-script'

// Importing the global css file
import '@/assets/global.css'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(Buefy, axios, firebase)
Vue.use(require('vue-script2'))

Vue.use(VueMobileDetection)
Vue.use(LoadScript)
// Vue.use(Ads.Adsense)

new Vue({
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyD_rrjNxH9LfmKB0Y0uy7nSfz0zHvvM_Iw',
      authDomain: 'bestiefy.firebaseapp.com',
      databaseURL: 'https://bestiefy.firebaseio.com',
      projectId: 'bestiefy',
      storageBucket: 'bestiefy.appspot.com'
    })
  },
  i18n,
  render: h => h(App)
}).$mount('#app')
